import { useState } from "react";
import { ChevronDown, ChevronRight, Eye, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, money } from "@/lib/api";

const LIBELLES = { pas_locataire: "Pas locataire", ancien: "Était locataire" };

const Ligne = ({ p, onChange }) => {
  const [busy, setBusy] = useState(false);
  const reafficher = async () => {
    setBusy(true);
    try {
      await api.delete(`/payeurs/masques/${encodeURIComponent(p.motcle)}`);
      toast.success(`« ${p.motcle} » réaffiché`);
      onChange();
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <li className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2" data-testid={`payeur-masque-${p.motcle}`}>
      <span className="font-mono text-xs">{p.motcle}</span>
      <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-mono text-slate-600">{LIBELLES[p.masque] || p.masque}</span>
      {p.masque === "ancien" && p.locataire && <span className="text-xs text-slate-500">{p.locataire.logement}</span>}
      <span className="text-xs text-slate-400 font-mono">{p.nb} virement(s) · {money(p.total)}</span>
      <Button size="sm" variant="ghost" className="ml-auto h-7 text-xs" disabled={busy} onClick={reafficher} data-testid={`payeur-reafficher-${p.motcle}`}>
        {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Eye className="h-3.5 w-3.5 mr-1" />}Réafficher
      </Button>
    </li>
  );
};

export const PayeursMasques = ({ rows, onChange }) => {
  const [ouvert, setOuvert] = useState(false);
  if (!rows.length) return null;
  return (
    <div className="mt-3 border-t border-slate-100 pt-2" data-testid="payeurs-masques">
      <button type="button" onClick={() => setOuvert((o) => !o)} data-testid="payeurs-masques-toggle"
        className="inline-flex items-center gap-1 text-xs text-slate-500 transition-colors hover:text-slate-800">
        {ouvert ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />}
        {ouvert ? "Masquer" : "Afficher"} les payeurs masqués ({rows.length})
      </button>
      {ouvert && <ul className="mt-1 divide-y divide-slate-100">{rows.map((p) => <Ligne key={p.motcle} p={p} onChange={onChange} />)}</ul>}
    </div>
  );
};
